module.exports = __webpack_public_path__ + "static/media/Tipo_virtual.92b280fb.png";